<script>
import ContentEditable from "vue-contenteditable/src/contenteditable.vue";
export default {
    extends: ContentEditable,
    props: {
        template: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return { raw: "" };
    },
    watch: {
        template: {
            immediate: true,
            handler(value) {
                this.translate(this.value, value);
            },
            deep: true
        },
        value(value) {
            if (value && /(?=.*{)(?=.*})/gm.test(value)) {
                this.raw = value;
                this.translate(value, this.template);
            }
        }
    },
    mounted() {
        this.translate(this.value, this.template);
    },
    methods: {
        richTranslate(string, template) {
            let compiled = "";
            let element = $(`<div>${string}</div>`);
            if (element.find("span[key]").length) {
                element.find("span[key]").each(function () {
                    let key = $(this).attr("key");
                    if (
                        key &&
                        Object.prototype.hasOwnProperty.call(template, key)
                    ) {
                        $(this).text(template[key] ? template[key] : "[ - ]");
                    }
                });
                compiled = element.html();
            }

            compiled = (compiled || string).replace(
                /{(\w*)}/g,
                (key, cleanKey) => {
                    return Object.prototype.hasOwnProperty.call(
                        template,
                        cleanKey
                    ) && template[cleanKey]
                        ? '<span key="' +
                              cleanKey +
                              '">' +
                              template[cleanKey] +
                              "</span>"
                        : '<span key="' + cleanKey + '">[ - ]</span>';
                }
            );
            return compiled;
        },
        plainTranslate(string, template) {
            return string.replace(/{(\w+)}/g, function (key, cleanKey) {
                return template[cleanKey] &&
                    Object.prototype.hasOwnProperty.call(template, cleanKey)
                    ? template[cleanKey]
                    : "[ - ]";
            });
        },
        translate(string, template) {
            if (string && _.keys(template).length) {
                if (this.noHTML) {
                    if (!this.raw) {
                        this.raw = string;
                    }
                    string = this.plainTranslate(this.raw, template);
                } else {
                    string = this.richTranslate(string, template);
                }
                this.$emit("input", string);
            }
        }
    }
};
</script>
